// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__twqNM","title":"Info_title__1-LGT","links":"Info_links__mz69O","link":"Info_link__jYV2P","logo":"Info_logo__2J3Dc"};